<div *ngIf="mobile" class="ion-hide-lg-up">
  <ion-content class="one3d-acc-list-mobile" scrollY="false">
    <div class="one3d-acc-list-header">
      <button class="one3d-accessories-nav-arrow" (click)="closeAccessories()">
        <ion-icon color="dark" name="chevron-back" size="small"></ion-icon>
      </button>
      <h4 class="one3d-acc-list-header-title" translate>ADD_ONS.ADD_ONS</h4>
    </div>
    <accessory-listing
      from="addons"
      [accessoriesList]="addonsAccessories"
    ></accessory-listing>
  </ion-content>
</div>
<div *ngIf="!mobile">
  <accessory-listing
    from="addons"
    [accessoriesList]="addonsAccessories"
  ></accessory-listing>
</div>
